// extracted by mini-css-extract-plugin
export default {"overlay":"PeopleOverflowTooltip_overlay__fsWUo","names":"PeopleOverflowTooltip_names__Kt1jn","name":"PeopleOverflowTooltip_name__SJ8Ji","more":"PeopleOverflowTooltip_more__yd-m3"};